import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ProofBar from '../components/ProofBar';
import Problems from '../components/Problems';
import BeforeAfter from '../components/BeforeAfter';
import HowItWorks from '../components/HowItWorks';
import Solver from '../components/Solver';
import Savings from '../components/Savings';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Home: React.FC = () => {
  useScrollReveal();

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Sort My Business With AI",
    "url": "https://sortmybusinesswithai.com",
    "logo": "https://sortmybusinesswithai.com/Sort my business with ai LOGO.png",
    "description": "Business automation and AI-powered systems for Irish and UK businesses. Streamline operations, boost sales, and save time.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+353-87-2526280",
      "contactType": "Customer Service"
    },
    "sameAs": []
  };

  return (
    <>
      <SEOHead
        title="Sort My Business With AI | You Run Your Business. We Handle the Rest."
        description="Business automation for Irish and UK businesses. Save 11+ hours a week, close more sales, get paid faster. Book a free 30-minute call today."
        canonical="https://sortmybusinesswithai.com"
        schema={schema}
      />
      <Navbar />
      <main>
        <Hero />
        <ProofBar />
        <Problems />
        <BeforeAfter />
        <HowItWorks />
        <Solver />
        <Savings />
        <CTASection />
      </main>
      <Footer />
    </>
  );
};

export default Home;
